import getOssPlayInstance from "./ossPlay"

/**
 * 两英一汉
 * @param word - 英文单词
 * @param paraphrase - 中文释义
 * @param speed - 速度
 */
export function playUniversalFormulaAudio(word, paraphrase, speed) {
  const audioType = localStorage.getItem("audioType") || "DN001"
  ossPlayTwoEnglishOneChineseAudio(word, paraphrase, speed / 50, speed, audioType)
}

/**
 * 两英一汉OSS版
 * @param word - 英文单词
 * @param paraphrase - 中文释义
 * @param speed - 速率
 */
let audio = null
export function ossPlayTwoEnglishOneChineseAudio(word, paraphrase, rate, speed, audioType) {
  let msg = word + "#" + word + "#" + paraphrase
  if (!audio || (audio && !audio?.loading)) {
    audio = getOssPlayInstance().init({
      msg: msg,
      rate: rate,
      speed: speed,
      audioPath: audioType,
    })
    audio.play()
  }
}
